import React from "react";
import { useNavigate } from "react-router-dom";
import Search from "./Autocomplete";
export default function SearchWithNavigate(props) {
  const navigate = useNavigate();
  return <Search {...props} navigate={navigate} />;
}
